module.exports = __webpack_public_path__ + "img/shiba-body-level6.7c0bf713.png";